import WitnessBadge from "./WitnessBadge";
import WitnessTaskProgress from "./WitnessTaskProgress";
import WitnessHold from "./WitnessHold";

export default {
    "witness-task-progress": WitnessTaskProgress,
    "witness-badge": WitnessBadge,
    "witness-hold": WitnessHold
}